<div class="flex flex-col gap-2 w-full max-w-ultrawide mt-4">
    <label class="font-medium text-neutral-700">{{ 'admin.formula' | transloco }}</label>

    <!-- Wrapper needed for absolute dropdown -->
    <div class="relative rounded-lg border border-border bg-neutral-50 hover:bg-neutral-100 transition-colors">
        <!-- Leading # -->
        <div class="absolute left-3 top-3 text-neutral-400 select-none">#</div>

        <!-- Input -->
        <textarea #formulaRef id="formula" [(ngModel)]="formula" (keydown)="onKeydown($event)"
            placeholder="e.g., #Contract End Date - today()"
            class="w-full pl-8 pr-3 pt-3 pb-10 bg-transparent resize-none text-neutral-700 placeholder-neutral-400 focus:outline-none focus:ring-0"
            rows="2"></textarea>

        <!-- Hint -->
        <div class="absolute bottom-1 left-3 text-xs text-neutral-400 flex flex-wrap gap-1 pr-3">
            {{'admin.press' | transloco }} <span class="font-semibold">#</span> {{ 'admin.to_insert_indicators' |
            transloco}}
            <span class="font-mono">{{ functionsHint }}</span>
        </div>

        <!-- Functions dropdown -->
        <div *ngIf="showFuncMenu"
            class="absolute z-20 mt-1 w-full max-w-xl bg-white border border-border rounded-xl shadow-lg p-2 max-h-[300px] overflow-y-auto"
            style="left: 0; top: 100%;">

            <!-- Selector for data type -->
            <div class="w-full flex flex-wrap">
                <div *ngFor="let tab of tabs; trackBy: trackById" (click)="selectTab(tab.id)"
                    class="flex-[1] min-w-[150px] cursor-pointer transition-colors" role="tab"
                    [attr.aria-selected]="selectedTabId === tab.id">
                    <div class="flex flex-col gap-2">
                        <p class="text-center font-medium"
                            [ngClass]="{'text-success-500': selectedTabId === tab.id, 'text-neutral-500 hover:text-neutral-700': selectedTabId !== tab.id}">
                            {{ tab.label | transloco}}
                        </p>
                        <div class="w-full h-[2px] rounded-full transition-colors"
                            [ngClass]="{'bg-success-500': selectedTabId === tab.id, 'bg-border': selectedTabId !== tab.id}">
                        </div>
                    </div>
                </div>
            </div>

            @if(selectedTabId == FormulaMenuTab.FUNCTIONS)
            {
            <button *ngFor="let f of logicFuncs" type="button" (click)="insertFunction(f.label)"
                class="w-full text-left px-3 py-2 rounded-lg hover:bg-success-100 focus:bg-success-100 transition flex items-start gap-2">
                <div class="flex-[1]">
                    <div class="font-medium text-neutral-800">#{{ f.label }}</div>
                    <div class="text-sm text-neutral-500">{{ f.description }}</div>
                </div>
                <span class="self-start text-[10px] px-2 py-1 bg-neutral-100 text-neutral-500 rounded-md border">{{
                    'admin.functions' | transloco }}</span>
            </button>
            }
            @else if(selectedTabId == FormulaMenuTab.INDICATORS)
            {
            <button *ngFor="let f of indicators" type="button" (click)="insertFunction(f.name)"
                class="w-full text-left px-3 py-2 rounded-lg hover:bg-success-100 focus:bg-success-100 transition flex items-start gap-2">
                <div class="flex-[1]">
                    <div class="font-medium text-neutral-800">#{{ f.name }}</div>
                    <div class="text-sm text-neutral-500">{{ f.description }}</div>
                </div>
                <span class="self-start text-[10px] px-2 py-1 bg-neutral-100 text-neutral-500 rounded-md border">{{
                    'admin.indicators' | transloco }}</span>
            </button>
            }
            @else if(selectedTabId == FormulaMenuTab.VARIABLES)
            {
            <button *ngFor="let f of variables" type="button" (click)="insertFunction(f.public_name)"
                class="w-full text-left px-3 py-2 rounded-lg hover:bg-success-100 focus:bg-success-100 transition flex items-start gap-2">
                <div class="flex-[1]">
                    <div class="font-medium text-neutral-800">#{{ f.public_name }}</div>
                    <div class="text-sm text-neutral-500">{{ f.type }}</div>
                </div>
                <span class="self-start text-[10px] px-2 py-1 bg-neutral-100 text-neutral-500 rounded-md border">{{
                    'admin.variables' | transloco }}</span>
            </button>
            }
        </div>
    </div>
</div>